<template>
  <!-- ============================================================== -->
  <!-- Page wrapper  -->
  <!-- ============================================================== -->
  <div class="page-wrapper">
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container-fluid">
      <!-- ============================================================== -->
      <!-- Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row page-titles">
        <div class="col-md-5 align-self-center">
          <h4 class="text-themecolor">Personal Setting</h4>
        </div>
        <div class="col-md-7 align-self-center text-right">
          <div class="d-flex justify-content-end align-items-center">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="dashboard">Home</a></li>
              <li class="breadcrumb-item active">Personal Setting</li>
            </ol>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <form class="needs-validation floating-labels m-t-40">
            <div class="row">
              <div
                class="form-group m-b-40 col-md-6 mb-3"
                v-bind:class="[userInfo.firstName != null ? 'focused' : '']"
              >
                <input
                  type="text"
                  class="form-control"
                  id=""
                  placeholder=""
                  maxlength="60"
                  required
                  v-model="userInfo.firstName"
                /><span class="bar"></span>
                <label for="">First Name</label>
              </div>

              <div
                class="form-group m-b-40 col-md-6 mb-3"
                v-bind:class="[userInfo.lastName != null ? 'focused' : '']"
              >
                <input
                  type="text"
                  class="form-control"
                  id=""
                  placeholder=""
                  maxlength="60"
                  required
                  v-model="userInfo.lastName"
                /><span class="bar"></span>
                <label for="">Last Name</label>
              </div>

              <div class="form-group m-b-40 col-md-6 mb-3" style="display:none" >
                <!-- <div class="col-md-6 mb-3" style="margin-top:16px"> -->
                <label>Choose User Type</label>
                <select
                  class="form-control custom-select"
                  tabindex="1"
                  v-model="userTypeId"
                >
                  <option value="0">--User Type--</option>
                  <option
                    v-for="item in userTypeList"
                    v-bind:value="item.userTypeID"
                    v-bind:key="item.userTypeID"
                  >
                    {{ item.typeName }}
                  </option>
                </select>
                <span class="bar"></span>
                <!-- </div> -->
              </div>

              <div
                class="form-group m-b-40 col-md-6 mb-3"
                v-bind:class="[userInfo.doBstr != null ? 'focused' : '']"
              >
                <label style="margin-top: 1px" for="">Date of Birth</label>
                <input
                  type="date"
                  class="form-control"
                  id="dob"
                  placeholder=""
                  required
                  v-model="userInfo.doBstr"
                /><span class="bar"></span>
              </div>

              <div
                class="form-group m-b-40 col-md-6 mb-3"
                v-bind:class="[userInfo.email != null ? 'focused' : '']"
              >
                <input
                  disabled
                  type="text"
                  class="form-control"
                  id=""
                  placeholder=""
                  required
                  v-model="userInfo.email"
                /><span class="bar"></span>
                <label for="">Email</label>
              </div>

              <div
                class="form-group m-b-40 col-md-6 mb-3"
                v-bind:class="[userInfo.phone != null ? 'focused' : '']"
              >
                <input
                  v-mask="'###-###-####'"
                  type="tel"
                  class="form-control"
                  id=""
                  placeholder=""
                  required
                  v-model="userInfo.phone"
                /><span class="bar"></span>
                <label for="">Phone Number</label>
              </div>

              <div
                class="form-group m-b-40 col-md-6 mb-3"
                v-bind:class="[userInfo.password != null ? 'focused' : '']"
              >
                <input
                  type="password"
                  class="form-control"
                  id=""
                  placeholder=""
                  minlength="3"
                  maxlength="30"
                  required
                  v-model="userInfo.password"
                /><span class="bar"></span>
                <label for="">Password</label>
              </div>

            
              <div class="form-group m-b-40 col-md-6 mb-3">
                <p class="boldText">Upload Picture</p>
                <input
                  type="file"
                  id="fileUpload"
                  class='dropify'
                  accept="image/*"
                  @change="getImage"
                />
               
              </div>
            
              <div class="form-group m-b-40 col-md-6 mb-3">
                
              </div>
              <button
                class="btn btn-lg mt-4 btn-outline-success col-12"
                @click="UpdateUserInfo()"
                id="ProfileUpd_btn"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
      <!-- <div style="width:100%;text-align: center">
                    <img id="image" ref="myimage" :src="SingleImage.Image"/>
                    </div> -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Container fluid  -->
    <!-- ============================================================== -->
  </div>
  <!-- ============================================================== -->
  <!-- End Page wrapper  -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- footer -->
  <!-- ============================================================== -->
  <footer class="footer">© 2020 RTPMedicalSolution.com</footer>
  <!-- ============================================================== -->
  <!-- End footer -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- End Wrapper -->
  <!-- ============================================================== -->

  <!-- Show picture Modal-->
  <div
    class="modal bs-example-modal-lg fade"
    id="showPictureModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
    style="display: none"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Crop Image</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
            @click="closePracticeModal"
          >
            x
          </button>
        </div>
        <div class="modal-body">
          <cropper
            ref="croppieRef"
            class="cropper"
            :src="SingleImage.Image"
            :stencil-props="{ handler:{}, aspectRatio: 10 / 12, movable: false, scalable: false}"
            :resize-image="{ adjustStencil: false }"
            image-restriction="stencil"
            @change="change"
          />
          <div class="col-md-12 pl0 talignc">
            <button class="btn btn-kips" @click="finishCropping('crop')">
              OK
            </button>
            <button class="btn btn-kips" @click="finishCropping">Cancel</button>
          </div>
          <div style="width: 100%; text-align: center">
            <!-- <img id="image" ref="myimage" :src="SingleImage.Image"  /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Alert V2 -->
 
</template>

<script>
import axios from "axios";
import moment from "moment";
import "mosha-vue-toastify/dist/style.css";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  components: {
    Cropper,
  },
  data() {
    return {
      demo:[],
      TimerObject: {},
      UserID: null,
      locationFile: "",
      fileName: null,
      userInfo: {},
      userTypeList: [],
      userTypeId: "0",
      SingleImage: {},
      img: {},
      cropper: {},
      destination: {},
    };
  },
  methods: {
    finishCropping(eventType) {
      if (eventType == "crop") {  
       var objData= this.$refs.croppieRef.getResult();
       this.SingleImage.Image=objData.canvas.toDataURL();
      }  

      $(".dropify-render img")[0].src=this.SingleImage.Image
      $("#showPictureModal").hide();
      $('#showPictureModal').modal('hide');
    },
    change({ coordinates, canvas }) {
      console.log(coordinates, canvas);
    }, 
    GetUserInfo(UserId) {
      const url = this.SERVER + "/VNSPRAAPI/Practices/GetUser?userId=" + UserId;
     
      this.axiosGetUserData(url, 1);
    },
    async axiosGetUserData(Url) {
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      //console.log("GetData");
      await axios({
        method: "get",
        url: Url,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          const result = res.data.userInfo;
          const listType = res.data.typeList;
          if (result) {
            this.userInfo = result;
            var date = moment(String(result.dob)).format("YYYY-MM-DD");
            this.userInfo.doBstr = date;
            this.userTypeList = listType;
            if (result.userType == null) {
              result.userType == "";
            } else {
              this.userTypeId = String(result.userType);
            }
          }
        })
        .catch(function (error) {
          alert(console.log(error));
        })
        .finally(() => {
          this.ResetLogoutTime()
          loader.hide();
        });
    },

    UpdateUserInfo() {
      if (!this.userInfo.firstName) {
        this.alertWarning("First Name is required");
        event.preventDefault();
        return;
      } else if (!this.userInfo.lastName) {
        this.alertWarning("Last Name is required");
        event.preventDefault();
        return;
      } else if (!this.userInfo.password) {
        this.alertWarning("Password is required");
        event.preventDefault();
        return;
      } else if (this.userInfo.phone == "") {
        this.alertWarning("Phone is required");
        event.preventDefault();
        return;
      } else if (this.userInfo.phone.length < 12) {
        this.alertWarning("Phone# digits are less then required!");
        event.preventDefault();
        return;
      } else if (typeof this.userInfo.doBstr === "undefined") {
        this.alertWarning("Date of Birth is required");
        event.preventDefault();
        return;
      } else if (this.userInfo.doBstr) {
        var today = new Date();
        var Dob = document.getElementById("dob").value;
        var pattern = /(\d{2})\.(\d{2})\.(\d{4})/;
        Dob = new Date(Dob.replace(pattern, "$3-$2-$1"));
        var age = today.getFullYear() - Dob.getFullYear();
        var m = today.getMonth() - Dob.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < Dob.getDate())) {
          age--;
        }
        if (age < 18) {
          this.alertWarning("Age should be greater than 18");
          event.preventDefault();
          return;
        }
      }
      if (this.userInfo.password.length < 5) {
        this.alertWarning("Password too short.");
        event.preventDefault();
        this.Clear();
        return;
      }
      event.preventDefault();
      if (typeof this.SingleImage.Image === "undefined") {
        console.log('ok');
      } else {
        var str = this.SingleImage.Image;
        str = str.substring(22);
        if (str.charAt(0) == ",") {
          str = str.substring(1);
        }
        this.userInfo.image = str;
      }
      this.userInfo.userId = this.UserID;
      this.userInfo.userType = this.userTypeId;
      this.userInfo.LocationFile = this.locationFile;

      $("#ProfileUpd_btn").prop("disabled", true);
      const url = this.SERVER + "/VeinsAPI/Practices/UpdateUser";
      this.axiosUpdateUserData(url, 1);
    },
    async axiosUpdateUserData(Url) {
      var loader = this.$loading.show({
        color: "#03a9f3",
      });
      await axios({
        method: "post",
        data: this.userInfo,
        url: Url,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          this.$store.dispatch("setImage", res.data);
          const result = res.data;
          if (result.status) {
            this.successToastUpd();
          } else if (result.message == "Invalid Date of Birth!") {
            this.alertWarning(result.message);
          } else {
            this.errorToastUpd(result.message);
          }
        })
        .catch(function () {})
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
          this.GetUserInfo(this.UserID);
          $("#ProfileUpd_btn").prop("disabled", false);
        });
      this.fileName = null;
    },
    
    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },

    getImage(event) {
      $("#showPictureModal").modal();
      $("#showPictureModal").show();
       this.fileName = event.target.files[0].name;
       this.locationFile = event.target.value;
      var reader = new FileReader();
      reader.onload = () => {
        this.SingleImage.Image = reader.result;
      };
       reader.readAsDataURL(event.target.files[0]);
      this.ImageCropper();
    },
    ImageCropper() {
      this.img = this.$refs.myimage;
    },
  },
  mounted() {
    clearTimeout(this.loadObj);
    $('.dropify').dropify();
    const str = localStorage.OSversion;
    const arr = str.split(this.UKEY);
    var UserId = arr[0] * 1;
    this.UserID = UserId;
    this.img = this.$refs.myimage;
    this.GetUserInfo(UserId);
    this.StartLogoutTime();
  },
unmounted() {
        clearTimeout(this.TimerObject);
      },

  watch: {},
};
</script>
<style scoped>
.mb-3,
.my-3 {
  margin-bottom: 2rem !important;
}
/* .cropper-view-box,
.cropper-face{
    border-radius: 50%;
}  */
img {
  display: block;
  /* This rule is very important, please don't ignore this */
  max-width: 100%;
}
.cropper {
  height: 600px;
  background: #ddd;
}
</style>
